import 'yet-another-abortcontroller-polyfill';
import 'whatwg-fetch';
import * as Browser from './Browser';
import * as UnifyHeight from './UnifyHeight';

const defaultSetting = {
    method: 'GET',
    body: undefined,
    signal: undefined,
    ignoreHistory: false,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
};

if(window.ajaxInitialized !== true) {
    window.addEventListener('popstate', function(event) {
        console.log('popstate begin');
        console.log(event);
        if (event.state !== null && event.state.hasOwnProperty('ajaxRequest')) {
            console.log('popstate ajax');
            sendRequest({
                url: event.state.ajaxRequest,
                ignoreHistory: true,
            });
        } else {
            if (event.state === null || event.state.hasOwnProperty('tabChange') === false) {
                console.log('popstate redirect');
                Browser.redirect(window.location.href);
            }
        }
    });
}
window.ajaxInitialized = true;

function drawSnippets(snippets) {
    Object.keys(snippets).map(function(snippetId) {
        if (snippetId === 'snippet--head') {
            console.log('headSnippet');
            let snippetHtml = (new DOMParser()).parseFromString(snippets[snippetId], 'text/html');
            let title = document.querySelector('title');
            if (title !== null) {
                title.innerText = snippetHtml.querySelector('title').innerText;
            }

            document.querySelector('link[canonical]')?.setAttribute('href', snippetHtml.querySelector('link[canonical]').getAttribute('href'));

            snippetHtml.querySelectorAll('meta[name]').forEach(function(meta) {
                document.querySelector('meta[name="'+meta.getAttribute('name')+'"]')?.setAttribute('content', meta.getAttribute('content'))
            });

            snippetHtml.querySelectorAll('meta[property]').forEach(function(meta) {
                document.querySelector('meta[property="'+meta.getAttribute('property')+'"]')?.setAttribute('content', meta.getAttribute('content'))
            });

            let newCanonical = snippetHtml.querySelector('link[rel="canonical"]');
            let currentCanonical = document.querySelector('link[rel="canonical"]');

            if (newCanonical !== null) {
                if (currentCanonical !== null) {
                    currentCanonical.setAttribute('href', newCanonical.getAttribute('href'))
                } else {
                    let newElement = document.createElement('link');
                    newElement.setAttribute('rel', 'canonical');
                    newElement.setAttribute('href', newCanonical.getAttribute('href'));
                    document.head.appendChild(newElement);
                }
            } else if(currentCanonical !== null) {
                document.head.removeChild(currentCanonical);
            }

            loadHeadScripts(snippetHtml);
        } else {
            let snippet = document.getElementById(snippetId);
            snippet.innerHTML = snippets[snippetId];
            loadscripts(snippet);
        }
    });
}

function loadscripts(snippet) {
    let scripts = snippet.querySelectorAll('script');
    scripts.forEach(function(script, key) {
        let scriptEl = document.createElement('script');
        scriptEl.innerHTML = script.innerHTML;

        if (script.hasAttributes()) {
            const attrs = script.attributes;
            for (let j = 0; j < attrs.length; j++) {
                const attrName = attrs[j].name;
                scriptEl[attrName] = attrs[j].value;
            }
        }

        document.head.appendChild(scriptEl);
        scripts[key].parentNode.removeChild(scripts[key]);
    });
}

function loadHeadScripts(snippet) {
    let scripts = snippet.querySelectorAll('script');

    scripts.forEach(function(script, key) {
        if (script.hasAttribute('src') === false) {
            let scriptEl = document.createElement('script');
            scriptEl.innerHTML = script.innerHTML;

            if (script.hasAttributes()) {
                const attrs = script.attributes;
                for (let j = 0; j < attrs.length; j++) {
                    const attrName = attrs[j].name;
                    scriptEl[attrName] = attrs[j].value;
                }
            }

            document.head.appendChild(scriptEl);
            scripts[key].parentNode.removeChild(scripts[key]);
        }
    });
}

function processSnippets(response) {
    if(response.hasOwnProperty('snippets')) {
        drawSnippets(response.snippets);
        UnifyHeight.applyTo('.js-unify-height');
        UnifyHeight.applyDataAttribute();
    }

    return response;
}

function processUrlChange(response)  {
    if(response.hasOwnProperty('newUrl')) {
        console.log('push');
        Browser.changeUrl(response.newUrl, {
            ajaxRequest: response.newUrl,
        });
    }

    return response;
}

function processRedirection(response) {
    if(response.hasOwnProperty('redirect')) {
        Browser.redirect(response.redirect);
    }

    return response;
}

function prepareFetchSettings(requestSettings) {
    let state = {
        request: {
            credentials: 'include',
            method: requestSettings.method.toUpperCase(),
            body: requestSettings.body,
            headers: new Headers(requestSettings.headers),
            signal: requestSettings.signal,
        }
    }

    return startSpinner(state);
}

function startSpinner(state) {
    console.log('Spinner start');
    let spinner = document.querySelector('[data-spinner]');

    if(spinner) {
        spinner.classList.remove('d-none');
    }

    return Object.assign({}, state, {
        spinner: spinner ?? null
    });
}

function stopSpinner(state) {
    console.log('Spinner stop');
    if(state.spinner) {
        state.spinner.classList.add('d-none')
    }

    return Object.assign({}, state, {
        spinner: state.spinner,
    });
}

export function sendRequest(requestSettings = {})
{
    const settings = Object.assign({}, defaultSetting, requestSettings);
    const fetchSettings = prepareFetchSettings(settings);

    return fetch(
        requestSettings.url, fetchSettings.request
    ).then(response => { // vytahne z odezvy JSON a preda dal
        console.log('NetteAjax: test1');
        return response.json();
    }).then(response => {// Ověříme jestli response neposlala pokyn k aktualizaci adresy browseru
        console.log('NetteAjax: test2', response);
        return requestSettings.ignoreHistory ? response : processUrlChange(response);
    }).then(response => { // Ověříme jestli nepřišel pokyn k přesměrování
        console.log('NetteAjax: test3', response);
        return processRedirection(response);
    }).then(response => {// Ověříme jestli response vratila snippety a připadně je překreslíme
        console.log('NetteAjax: test4', response);
        return processSnippets(response);
    }).then(response => {
        console.log('NetteAjax: test5', response);
        return Object.assign({}, {request: fetchSettings.request, response: response, spinner: fetchSettings.spinner});
    }).then(response => {
        console.log('NetteAjax: test6', response);
        stopSpinner(response);
        return response;
    }).catch(function(error) {
        console.log('NetteAjax: error', error);
    });
}
